<template>
  <div class="" :value="value" v-show="showPop">
    <van-dialog
      v-model="showPop"
      show-cancel-button
      confirmButtonText="保存"
      @confirm="add"
    >
      <van-cell-group>
        <van-cell title="名称">
          <van-field   placeholder="请输入名称" class="item2" v-model="obj.Name" @input="limitLength(64,'obj','Name')"/>
        </van-cell>
        <van-cell title="数量">
          <van-field type="number"  placeholder="请输入数量" class="item2" v-model="obj.U_Qty" @input="limitLength(15,'obj','U_Qty')"/>
        </van-cell>
        <van-cell title="含税金额">
          <van-field type="number" maxlength="15"  placeholder="请输入含税金额" class="item2" v-model="obj.U_AmountAftTax" @input="weiShui"/>
        </van-cell>
        <van-cell title="未税金额">
          <van-field type="number"  maxlength="15" placeholder="请输入未税金额" class="item2" v-model="obj.U_Amount" @input="hanShui"/>
        </van-cell>
      </van-cell-group>
    </van-dialog>
  </div>
</template>
<script>
  import moment from 'moment'
  export default{
    data(){
      return {
        obj:{
          U_Sort:'',
          Name : '',
          U_Qty : "",
          U_Amount:0,
          U_AmountAftTax:0
        },
        showPop:false,
        showDateTime:false,
      }
    },
    props:{
      value:{
        type:Boolean,
        default:false
      },
      info:{}
    },
    watch:{
      value(val){
        this.showPop = val
      },
      showPop(val){
        if(!val){
          this.obj={
            Name : '',
            U_Qty : "",
            U_Amount:'',
            U_AmountAftTax:''
          }
        }else if(this.info){
          this.obj={
            U_Sort:this.info.U_Sort,
            Name : this.info.Name,
            U_Qty : this.info.U_Qty,
            U_Amount:this.info.U_Amount,
            U_AmountAftTax:this.info.U_AmountAftTax
          }
        }
        this.$emit('input',val)
      },
//      'obj.U_AmountAftTax':function(newVal,oldVal){
//          if(newVal){
//            let val = newVal/((this.$wxuserUtil.getDeptTaxRate()/100)+1)
//            if((val+'').length>15){
//              this.obj.U_AmountAftTax =oldVal
//            }
//          }
//
//      },
//      'obj.U_Amount':function(newVal,oldVal){
//        let val = newVal*((this.$wxuserUtil.getDeptTaxRate()/100)+1)
//        if((val+'').length>15){
//          this.obj.U_Amount =oldVal
//        }
//      }
    },
    methods:{
      add(){
        if(!this.obj.Name){
          this.$title('请输入名称')
          return
        }else if(!this.obj.U_Qty||!/(^[1-9]\d*$)/.test(this.obj.U_Qty)){
          this.$title('数量请输入正整数')
          return
        }else if(!this.obj.U_Amount||this.obj.U_Amount.length>15){
          this.$title('请输入15位数内的未税金额')
          return
        }else if(!this.obj.U_AmountAftTax||this.obj.U_AmountAftTax.length>15){
          this.$title('请输入15位数内的含税金额')
          return
        }
        this.$emit('newYusuan',this.obj)
      },
      weiShui(){
        if(this.obj.U_AmountAftTax.length>15){
          this.obj.U_AmountAftTax=this.obj.U_AmountAftTax.slice(0,15)
          return
        }
        this.obj.U_Amount=this.obj.U_AmountAftTax/((this.$wxuserUtil.getDeptTaxRate()/100)+1)
        this.obj.U_Amount=this.obj.U_Amount.toFixed(2)
      },
      hanShui(){
        if(this.obj.U_Amount.length>15){
          this.obj.U_Amount=this.obj.U_Amount.slice(0,15)
          return
        }
        this.obj.U_AmountAftTax=this.obj.U_Amount*((this.$wxuserUtil.getDeptTaxRate()/100)+1)
        this.obj.U_AmountAftTax=this.obj.U_AmountAftTax.toFixed(2)
      },
      limitLength(len,key1,key2){
        let value = ''
        if(key2){
          value =this.$data[key1][key2]
        }else{
          value =this.$data[key1]
        }
        if(value.length>len){
          if(key2){
            this.$data[key1][key2]=value.slice(0,len)
          }else{
            this.$data[key1]=value.slice(0,len)
          }
        }
      }
    }
  }
</script>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../../style/pageStyle/pageView-activeDetail.less";
  .van-cell__title{
    width:60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/active/component/yusuanPop.vue